import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  DELETE_VACATION,
  INSERT_VACATION,
  UPDATE_VACATION,
} from "../../Graphql/mutations";
import { GET_USER_VACATIONS } from "../../Graphql/queries";
import { CustIcon } from "../Svgs";
import "./VacationManagement.less";

export const VacationManagement = () => {
  const location = useLocation();
  const user_id =
    location.pathname.split("/")[1] === "employee"
      ? location.pathname.split("/")[2]
      : localStorage.getItem("user_id");
  const [vacationTableData, setVacationTableData] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [disabledDates, setDisabledDates] = useState({
    start_date: moment().endOf("day"),
    end_date: moment().endOf("day"),
  });
  const [vacationForm] = Form.useForm();

  const vacationColumns = [
    {
      title: "Start Date",
      dataIndex: "start_date",
      //key: "start_date",
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      // key: "end_date",
    },
    {
      title: "Reason",
      dataIndex: "vacation_reason",
      key: "vacation_reason",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (data) => (
        <Space
          size="middle"
          className="text-center d-flex justify-content-center"
        >
          <span
            className="cursorPointer edit"
            onClick={() => editVacation(data)}
          >
            <CustIcon type="edit" />
          </span>
          <Popconfirm
            title="Are you sure to delete this leave?"
            onConfirm={() => confirmDelete(data.vacation_id)}
            placement="topRight"
            okText="Delete"
            cancelText="No"
          >
            <span className="cursorPointer delete">
              <CustIcon type="delete-o" />
            </span>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const [INSERT_VACATION_MUTATION, { loading: insertUserVacationLoading }] =
    useMutation(INSERT_VACATION);

  const [UPDATE_VACATION_MUTATION, { loading: updateUserVacationLoading }] =
    useMutation(UPDATE_VACATION);

  const [DELETE_VACATION_MUTATION, { loading: deleteUserVacationLoading }] =
    useMutation(DELETE_VACATION);

  const [
    GET_VACATION_QUERY,
    { data: userVacationData, loading: userVacationLoading, refetch },
  ] = useLazyQuery(GET_USER_VACATIONS);

  useEffect(() => {
    GET_VACATION_QUERY({
      variables: { user_id },
    });
  }, []);
  useEffect(() => {
    if (userVacationData) {
      setVacationTableData(userVacationData.user_vacations);
    }
  }, [userVacationData]);

  const onVacationAdd = async (value) => {
    setIsSubmitting(true);
    if (value.vacation_id) {
      const { data } = await UPDATE_VACATION_MUTATION({
        variables: value,
      });
      if (data.update_user_vacations_by_pk) {
        message.success("Vacation updated successfully");
      }
    } else {
      value.user_id = user_id;
      const { data } = await INSERT_VACATION_MUTATION({
        variables: value,
      });
      if (data.insert_user_vacations) {
        message.success("Vacation added successfully");
      }
    }
    setIsUpdate(false);
    setIsSubmitting(false);
    refetch();
    vacationForm.resetFields();
  };

  const confirmDelete = async (vacation_id) => {
    const { data } = await DELETE_VACATION_MUTATION({
      variables: {
        vacation_id,
      },
    });
    if (data.delete_user_vacations) {
      vacationForm.resetFields();
      message.success("Vacation Deleted successfully");
      refetch();
    }
  };

  const editVacation = async (vacationData) => {
    let data = vacationData;
    data.start_date = moment(new Date(vacationData.start_date));
    data.end_date = moment(new Date(vacationData.end_date));
    setIsUpdate(true);
    vacationForm.setFieldsValue(data);
  };

  return (
    <Row>
      <Col xs={24} sm={24} xl={24}>
        <div className="secSubTitle pageSubTilte">
          <div className="stLeft flex-column align-items-start">
            <h5 className="mb-2">Vacation Days</h5>
            <p className="mb-0">During this period, no tasks will be assigned and no notification goes to the employee.</p>
          </div>
        </div>
        <Form
          // layout="inline"
          className="w-100 vacation_Form"
          name="vacation-form"
          form={vacationForm}
          onFinish={onVacationAdd}
        >
          <Row gutter={20} className="mb-sm-0 mb-3">
            <Col xl={6} lg={6} sm={12} xs={24} className="mb-3">
              <Form.Item
                name="start_date"
                className="mb-0"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "Start date is required",
                    whitespace: true,
                  },
                ]}
              >
                <DatePicker
                  onChange={(v) => {
                    setDisabledDates((d) => {
                      d.end_date = moment(v).endOf("day");
                      return d;
                    });
                  }}
                  placeholder="Start Date"
                  disabledDate={(current) => {
                    return current && current < disabledDates.start_date;
                  }}
                />
              </Form.Item>
            </Col>
            <Col xl={6} lg={6} sm={12} xs={24} className="mb-3">
              <Form.Item
                name="end_date"
                className="mb-0"
                rules={[
                  {
                    type: "object",
                    required: true,
                    message: "End date is required",
                    whitespace: true,
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        getFieldValue("start_date").isBefore(value)
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("End Date can't be before start date")
                      );
                    },
                  }),
                ]}
              >
                <DatePicker
                  disabledDate={(current) => {
                    return current && current < disabledDates.end_date;
                  }}
                  placeholder="End Date"
                />
              </Form.Item>
            </Col>
            <Col xl={7} lg={6} sm={12} xs={24} className="mb-3">
              <Form.Item
                name="vacation_reason"
                className="vacation_reason"
                className="mb-0"
                rules={[
                  {
                    required: true,
                    message: "Vacation reason is required",
                    whitespace: true,
                  },
                ]}
              >
                <Input placeholder="Reason" />
              </Form.Item>
              <Form.Item name="vacation_id" className="d-none">
                <Input type="hidden" />
              </Form.Item>
            </Col>
            <Col
              xl={5}
              lg={6}
              sm={12}
              xs={24}
              className="text-sm-right text-center"
            >
              <Form.Item className="mb-0">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  className=""
                  success
                  htmlType="submit"
                  loading={
                    isSubmitting
                  }
                >
                  {isUpdate ? "Update" : "Add"}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Card>
          <Table
            loading={userVacationLoading}
            dataSource={vacationTableData}
            columns={vacationColumns}
          ></Table>
        </Card>
      </Col>
    </Row>
  );
};
